import { useState } from 'react';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import SEO from '../components/SEO';
import { db } from '../firebase';
import './Contact.css';

const initialFormData = {
  name: '',
  email: '',
  subject: '',
  message: '',
  intent: 'General feedback',
};

const Contact = () => {
  const [formData, setFormData] = useState(initialFormData);
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    setError('');

    try {
      await addDoc(collection(db, 'contactMessages'), {
        ...formData,
        source: 'ideapetal.com',
        createdAt: serverTimestamp(),
      });
      setStatus('submitted');
      setFormData(initialFormData);
    } catch (submitError) {
      setStatus('error');
      setError('Your message could not be saved yet. Please email support@ideapetal.com directly.');
    }
  };

  return (
    <>
      <SEO
        title="Contact Us"
        description="Contact IdeaPetal Games for support, feedback, advertising, partnerships, or game suggestions."
        keywords="contact IdeaPetal, game support, advertising, partnerships"
      />
      <div className="contact-page">
        <div className="contact-header">
          <div className="container">
            <h1>Contact Us</h1>
            <p>Send feedback, support questions, advertising requests, or partnership ideas.</p>
          </div>
        </div>

        <div className="contact-content">
          <div className="container">
            <div className="contact-grid">
              <div className="contact-info">
                <h2>Get in Touch</h2>
                <p>
                  Have a question, game suggestion, ad inquiry, or partnership idea? Send a message and we will review it.
                </p>

                <div className="info-item">
                  <h3>Email</h3>
                  <p>support@ideapetal.com</p>
                </div>

                <div className="info-item">
                  <h3>Advertising</h3>
                  <p>Use the form and choose Advertising / partnership for sponsorship and ad placement inquiries.</p>
                </div>

                <div className="info-item">
                  <h3>Response Time</h3>
                  <p>We typically respond within 24-48 hours.</p>
                </div>
              </div>

              <div className="contact-form-container">
                <h2>Send us a Message</h2>
                {status === 'submitted' ? (
                  <div className="success-message">
                    <p>Thank you for your message. We will get back to you soon.</p>
                  </div>
                ) : (
                  <form className="contact-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                      <label htmlFor="name">Name *</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="email">Email *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="intent">Reason *</label>
                      <select id="intent" name="intent" value={formData.intent} onChange={handleChange} required>
                        <option>General feedback</option>
                        <option>Game support</option>
                        <option>Advertising / partnership</option>
                        <option>New game suggestion</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <label htmlFor="subject">Subject *</label>
                      <input
                        type="text"
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="message">Message *</label>
                      <textarea
                        id="message"
                        name="message"
                        rows="6"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    {error && <p className="error-message">{error}</p>}

                    <button type="submit" className="submit-button" disabled={status === 'sending'}>
                      {status === 'sending' ? 'Sending...' : 'Send Message'}
                    </button>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
